<template>
  <div class="module-file-uploader">
    <!-- Input oculto -->
    <input id="fileInput" type="file" :accept="accept" :multiple="multiple" @change="handleFiles"
      class="module-file-input" />

    <!-- Label estilizado como botón -->
    <label for="fileInput" class="module-file-button w-full">
      <feather-icon icon="UploadIcon" class="pr-2"> </feather-icon>{{ $t('select_files') }}
    </label>

    <!-- Lista de archivos -->
    <ul v-if="files.length">
      <li v-for="(file, index) in files" :key="index" class="module-file-item">
        <span>{{ truncateText(file.name) }} ({{ formatSize(file.size) }})</span>
        <button class="module-file-remove" @click="removeFile(index)">✕</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FileUploader',
  props: {
    accept: { type: String, default: '' }, // ej: "image/*", ".pdf,.docx"
    multiple: { type: Boolean, default: false },
    maxSize: { type: Number, default: 2 }, // tamaño máximo en MB
    maxFiles: { type: Number, default: 5 } // cantidad máxima de archivos
  },
  data() {
    return {
      files: []
    }
  },
  methods: {
    handleFiles(event) {
      const selectedFiles = Array.from(event.target.files)

      // Validar tamaño
      const validFiles = selectedFiles.filter(file => {
        const sizeMB = file.size / 1024 / 1024
        return sizeMB <= this.maxSize
      })

      if (validFiles.length < selectedFiles.length) {
         this.$vs.notify({
          title: 'Alert!',
          text: `Algunos archivos exceden el tamaño máximo de ${this.maxSize} MB.`,
          color: 'warning'
        })
      }

      // Validar cantidad máxima
      if (validFiles.length > this.maxFiles) {

        this.$vs.notify({
          title: 'Alert!',
          text: `Solo puedes seleccionar hasta ${this.maxFiles} archivos.`,
          color: 'warning'
        })
        this.files = validFiles.slice(0, this.maxFiles)
      } else {
        this.files = validFiles
      }

      this.$emit('files-selected', this.files)
    },
    truncateText(text, length = 40) {
      return text.substring(0, length)
    },
    removeFile(index) {
      this.files.splice(index, 1)
      this.$emit('files-selected', this.files)
    },
    formatSize(size) {
      const mb = (size / 1024 / 1024).toFixed(2)
      return `${mb} MB`
    }
  }
}
</script>


<style scoped>
/* Ocultar input real */
.module-file-input {
  display: none;
}

.module-file-button {
  display: flex;
  /* Flexbox para alinear contenido */
  align-items: center;
  /* Centra verticalmente ícono y texto */
  justify-content: center;
  /* Centra horizontalmente */
  background: #BC1300;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  height: 40px;
}

.module-file-button:hover {
  background: #D51600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.module-file-button .feather-icon {
  margin-right: 0.5rem;
  /* Espacio entre ícono y texto */
  display: flex;
  align-items: center;
  /* Asegura que el ícono también quede centrado */
}


/* Lista */
.module-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  margin-top: 0.25rem;
}

/* Botón remover minimalista */
.module-file-remove {
  background: none;
  border: none;
  color: #e53935;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.2s;
}

.module-file-remove:hover {
  color: #b71c1c;
}
</style>